
export {__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
createPortal,
createRoot,
findDOMNode,
flushSync,
hydrate,
hydrateRoot,
render,
unmountComponentAtNode,
unstable_batchedUpdates,
unstable_renderSubtreeIntoContainer,
version} from '../../../frontend-js-react-web/__liferay__/exports/react-dom.js';
import __x__ from '../../../frontend-js-react-web/__liferay__/exports/react-dom.js';export default __x__;